import React from 'react'
import styled from 'styled-components'
import { QRCodeSVG } from 'qrcode.react'
import { trackEvent } from '../../analytics/client'
import { ANALYTICS_EVENTS } from '../../analytics/events'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`

const Panel = styled.div`
  background: #90d1a8;
  border-radius: 16px;
  padding: 32px 28px;
  text-align: center;
  max-width: 360px;
  width: 90%;
`

const Title = styled.h2`
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 24px;
`

const QRWrap = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  display: inline-block;
  margin-bottom: 12px;
`

const UrlText = styled.p`
  font-size: 14px;
  color: #2f4b3d;
  margin: 0 0 20px;
  word-break: break-all;
`

const Button = styled.button`
  display: block;
  width: 100%;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

const PrimaryButton = styled(Button)`
  background: #4f765f;
`

const SecondaryButton = styled(Button)`
  background: #6f9880;
`

const copyText = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).catch(() => {})
    return
  }
  const textarea = document.createElement('textarea')
  textarea.setAttribute('type', 'hidden')
  textarea.textContent = text
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

const ShareModal = ({ gameId, onClose }) => {
  const url = `${window.location.origin}/game/${gameId}`

  const onShare = () => {
    trackEvent(ANALYTICS_EVENTS.SHARE_INITIATED, {
      source: 'share_modal',
      gameId,
    })
    if (navigator.share) {
      navigator.share({
        title: 'Join this Crossword with me!',
        text: 'Join this Crossword with me!',
        url,
      }).then(() => {
        trackEvent(ANALYTICS_EVENTS.SHARE_COMPLETED, {
          source: 'share_modal',
          gameId,
        })
      }).catch(() => {})
    } else {
      copyText(url)
      window.alert('The URL has been copied to your clipboard!')
      trackEvent(ANALYTICS_EVENTS.SHARE_COMPLETED, {
        source: 'share_modal',
        method: 'clipboard',
        gameId,
      })
    }
  }

  const onOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <Overlay onClick={onOverlayClick}>
      <Panel>
        <Title>Share</Title>
        <QRWrap>
          <QRCodeSVG value={url} size={200} bgColor="#fff" fgColor="#333" />
        </QRWrap>
        <UrlText>{url}</UrlText>
        <PrimaryButton onClick={onShare}>Share Game Link</PrimaryButton>
        <SecondaryButton onClick={onClose}>Close</SecondaryButton>
      </Panel>
    </Overlay>
  )
}

export default ShareModal
